module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch8",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "aria-label": "12",
      "id": "pg_12",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch8",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Doing Without")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "VSB"
  }, [_vm._v("I find ways to numb the pain.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I write.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I release.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("And then I hide the notebooks under the blue")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("shag carpet")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("in the broom closet.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I keep your world immaculate.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("I try to please you when I know there is no")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("way to please someone "), _c('i', [_vm._v("who is displeased")])]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_c('i', [_vm._v("with life.")])]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I manage—"), _c('i', [_vm._v("doing without,")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("so your lifestyle does not change. The")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("children you take credit for are so beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I wish you knew")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("them.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I ask myself:")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("“How can I hate you, when you gave me")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("something so beautiful?”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec4c8466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter8.vue
// module id = 93
// module chunks = 0